<template>
	<div id="content">
		<link rel="stylesheet" href="/themes/ito/css/parents.css">

		<div class="container" v-if="!doPlacementTest">
			<div id="page-header-fixed" class="mb-25">
				<div class="container">
					<div id="page-header">
						<div class="buttons">
							<nav-tabs />
						</div>
					</div>
				</div>
			</div>

			<div id="upgrade-detail" class="card card-comments">
				<div class="card-body">
					<h5 class="card-title">
						<span class="title">{{ $t('unclock_full_access') }}</span>
					</h5>

					<div class="card-content" v-if="packages.length">
						<div class="d-flex flex-column">
							<!-- step 1 -->
							<SimpleSwiper class="pb-3" v-if="step == 0" :items="packages" :showNavigation="false" :showPagination="false" :loop="false" :autoplay="false" :slidesPerView="2" :slidesPerGroup="1" :spaceBetween="12" :breakpoints="{
								1024: { slidesPerView: 3, slidesPerGroup: 1, spaceBetween: 16 },
							}">
								<template #slide="{ item }">
									<div class="upgrade_package box-shadow-main" :class="{ active: package_select.id === item.id }" @click="package_select = item">
										<div class="package-title">{{ item.name }}</div>
										<div class="upgrade_package_content">
											<div class="package-items d-flex" v-if="item.desc" v-for="(desc, i) in item.desc">
												<img src="/themes/ito/images/payment-check-icon.svg">
												<div class="package-items-text">{{ desc }}</div>
											</div>
										</div>
									</div>
								</template>
							</SimpleSwiper>

							<!-- step 2 -->
							<div class="d-flex flex-column" v-if="step == 1">
								<p class="label-upgrade">{{ $t("select_to_pay") }}:</p>
								<ul class="w-100 d-flex flex-column list-group">
									<li class="list-group-item border-0 d-flex justify-content-between align-items-center box-shadow-main" :class="{ active: product.id === item.id }" v-for="item in package_select.products" @click="product = item">
										<div class="fs-5 fw-bold">
											{{ item.product_name }}
										</div>
										<div class="d-flex flex-column">
											<p class="fs-5 fw-bold">{{ toCommas(item.price) }} &#8363;</p>
											<p class="fs-6 text-end text-decoration-line-through" v-if="item.original_price && item.original_price > item.price">{{ toCommas(item.original_price) }} &#8363;</p>
										</div>
									</li>
								</ul>

								<div class="mt-3"><strong>(*) {{ $t("note") }}:</strong> {{ $t("upgrade_prices_differ_on_web_vs_mobile_payments") }}</div>
							</div>

							<!-- step 3 -->
							<div class="d-flex flex-column" v-if="step == 2">
								<div class="d-flex justify-content-between mb-3">
									<p> {{ `${$t("selected_package")}:` }} <strong>{{ product.product_name }}</strong> </p>
									<p class="fw-bold"> {{ `${toCommas(product.price)}&#8363;` }} </p>
								</div>
								<!-- <p class="label-upgrade">{{ $t('add_promotion_code') }}</p> -->
								<!-- <div class="d-flex align-items-center" style="margin-bottom: 12px">
									<input class="input-promotion" :placeholder="$t('enter_promotion_code')">
									<div class="ito-btn-small btn-promotion-code">{{ $t('apply_code') }}</div>
								</div> -->
								<p class="label-upgrade">{{ $t('choose_payment_method') }}</p>

								<div class="row row-cols-5">
									<div class="col flex-column payment-method-item box-shadow-main" :class="{ active: method === gate.method }" v-for="gate in gates" @click="method = gate.method">
										<div class="img-gate-box">
											<img :src="gate.icon">
										</div>
										<div class="payment-method-text" v-html="gate.name"></div>
									</div>
								</div>
							</div>

							<div class="d-flex justify-content-center align-items-center gap-3 mt-3">
								<button class="ito-btn ito-btn-light ito-btn-lg" v-if="!isFirst" @click="prev()">{{ $t('back') }}</button>
								<button v-if="step === 0" class="ito-btn ito-btn-primary ito-btn-lg" @click="next()" :disabled="!package_select">{{ $t('upgrade_account') }}</button>
								<button v-else-if="step === 2" class="ito-btn ito-btn-primary ito-btn-lg" @click="Payment()" :disabled="!product || !method">{{ $t('pay_now') }}</button>
								<button v-else class="ito-btn ito-btn-primary ito-btn-lg" @click="next()" :disabled="isLast">{{ $t('continue_txt') }}</button>
							</div>
						</div>
					</div>

					<div class="card-content" v-else>
						<p class="text-center p-5">{{ $t('empty_data') }}</p>
					</div>

				</div>
			</div>

			<div class="modal fade payment-popup" id="PopupPayment" tabindex="-1" role="dialog" aria-labelledby="PopupPayment" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 700px;">
					<div class="modal-content box-shadow-main">
						<div class="close-popup" data-bs-dismiss="modal"></div>
						<h3 class="popup-title mb-20">Payment confirmation</h3>
						<p><b>Your current account information:</b><br />
							Student ID (username): <b>demo_001</b><br />
							Current package: <b>iTO PLUS 12 months</b><br />
							Expire date: <b>19 May, 2022</b><br /><br />
							Bạn đang thực hiện mua gói cước <b>iTO PRO 1 months.</b><br />
							Nếu đồng ý thanh toán, gói cước mới sẽ thay thế cho gói <b>iTO PLUS 12 months</b> vẫn đang
							còn hiệu lực.<br /><br />
							Bạn có chắc chắn muốn thực hiện thanh toán?</p>
						<div class="form-group d-flex justify-content-center">
							<div class="ito-btn-small" style="margin: 0px 10px">Cancel</div>
							<div class="ito-btn-small active" style="margin: 0px 10px" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPaymentFail">Yes
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal fade payment-popup" id="PopupPaymentFail" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentFail" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 475px;">
					<div class="modal-content box-shadow-main paymment-status">
						<div class="close-popup" data-bs-dismiss="modal"></div>
						<h3 class="popup-title mb-20 fail">Payment unsuccessfully</h3>
						<img src="/themes/ito/images/payment-fail.png" width="87px">
						<div v-html="$t('payment_unsuccess_noti')"></div>
						<div class="form-group d-flex justify-content-center">
							<div class="ito-btn-small" style="margin: 0px 10px" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPaymentTransfer">Cancel
							</div>
							<div class="ito-btn-small active" style="margin: 0px 10px" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPaymentSuccess">Yes
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal fade payment-popup" id="PopupPaymentSuccess" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentSuccess" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 475px;">
					<div class="modal-content box-shadow-main paymment-status">
						<div class="close-popup" data-bs-dismiss="modal"></div>
						<h3 class="popup-title mb-20 success">Payment successful</h3>
						<img src="/themes/ito/images/payment-fail.png" width="87px">
						<div v-html="$t('payment_success_noti')"></div>
					</div>
				</div>
			</div>
			<div class="modal fade payment-popup" id="PopupPaymentTransfer" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentTransfer" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 700px;">
					<div class="modal-content box-shadow-main">
						<div class="close-popup" data-bs-dismiss="modal"></div>
						<h3 class="popup-title mb-20">How to use bank transfer method?</h3>
						<p>Please process payment as per below instruction to complete the upgrade.<br />
							<b>Account information after complete money transfer:</b><br />
							Student code (username): <b>demo_001</b><br />
							Renew package: <b>iTO PRO 12 months</b><br />
							Expected expired time: <b>19 May, 2022</b><br />
							<b>Instruction to make money transfer:</b><br />
							To upgrade, please make money transfer to iTO bank account according to the following
							information:<br />
							(1) Beneficiary name: <b>CÔNG TY CỔ PHẦN GIÁO DỤC ISMART</b><br />
							(2) Bank: <b>Vietcombank</b><br />
							(3) Account number: <b>87285789759872</b><br />
							(4) Branch: <b>Sai Thanh</b><br />
							(5) Total money: <b>150,000đ</b><br />
							(6) Content: <b>iTO [Student ID] [Phone number]</b><br />
							For example:<br />
							Customer has <b>Student ID</b> demo_001, <b>Phone number</b> 09xxxxxx00 demanding to
							register iTO1 package. Customer needs to enter the content of money transfer as follows:
							<b>iTO1 demo_001 09xxxxxxx00</b><br /><br />

							<b>Note:</b><br />
							In the content of transfer, the information “Student ID” and “Phone number” are required for
							the account upgrade process completed as soon as possible.<br />
							This request is auto cancelled by iTO after 72 hours (02 working days, except Saturday and
							Sunday) if you don't make money transfer to iTO bank account.
						</p>
					</div>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import axios from "axios";
import { soundClick, toCommas } from '../../utils/utils'
import { mapGetters } from 'vuex'
import { getPackages, postPayment } from "../../models/payment";
import NavTabs from "../NavTabs.vue";
import SimpleSwiper from "../common/SimpleSwiper.vue"
import { method } from "lodash";

export default {
	name: "UpgradeAccount",
	title: 'Upgrade Account',
	components: {
		NavTabs,
		SimpleSwiper
	},
	data() {
		return {
			packages: [],
			gates: [],
			product: null,
			package_select: null,
			method: null,

			steps: [
				{ title: this.$i18n.t('unclock_full_access'), key: 'package' },
				{ title: this.$i18n.t('unclock_full_access'), key: 'product' },
				{ title: this.$i18n.t('unclock_full_access'), key: 'payment' },
			],
			step: 0,
		};
	},

	created() {
		this.$store.commit('setMenuActive', 'parent');

		this.fetch();
	},

	computed: {
		...mapGetters([
			'user_info'
		], () => {
			if (this.user_info) {
				return this.user_info
			}

			return this.user
		}),

		doPlacementTest() {
			return this.user_info.placement_test === 0 && this.user_info.student_type !== 1;
		},

		current() { return this.steps[this.step] },

		isFirst() { return this.step <= 0 },

		isLast() { return this.step >= this.steps.length - 1 },
	},

	watch: {
		package_select: {
			handler(value) {
				if (value && value.products)
					this.product = value.products[0]
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		toCommas,
		fetch() {
			const that = this;
			that.$store.commit("setLoading", true);
			axios.all([
				getPackages(),
			]).then(axios.spread((package_response) => {
				that.$store.commit("setLoading", false);
				if (package_response.data.code != 0) {
					return;
				}
				that.packages = package_response.data.results.packages || [];
				if (that.packages.length > 0) {
					that.package_select = that.packages[0];
				}
				that.gates = package_response.data.results.gate || [];
			}));
		},


		next() {
			if (this.isLast) return
			this.step += 1
		},
		prev() {
			if (this.isFirst) return
			this.step -= 1
		},

		Payment() {
			const that = this;
			that.$store.commit("setLoading", true);
			const formData = new FormData();
			formData.append('product_id', this.product.product_id);
			formData.append('voucher', 'xxx');
			formData.append('method', this.method);
			postPayment(formData).then((data) => {
				that.$store.commit("setLoading", false);
				if (data.data.code == 0) {
					window.location.href = data.data.results.url;
				} else {
					alert(data.data.results);
				}
			}).catch(({ response }) => {
				that.$store.commit("setLoading", false);
				console.log('ect', response);
				alert(response.data.results);
			});
		},

		getSoundClick() {
			soundClick();
		},
	}
}
</script>

<style scoped>
.payment-method-item {
	outline: transparent 2px solid;
}

.payment-method-item.active {
	outline-color: #40C0F6;
}

.upgrade_package {
	padding: 15px 10px;
	margin: 0 5px 0 10px;
	background: #C1C1C1;
}

.upgrade_package .upgrade_package_content {
	flex-grow: 1;
	margin: 10px;
	border-radius: 8px;
	padding: 15px;
	overflow-x: auto;
	color: #000000;
	background: #FFFFFF;
}

.upgrade_package .upgrade_package_content img {
	filter: grayscale(1);
}

.upgrade_package.active,
.list-group-item.active {
	background: #E98437;
}

.upgrade_package.active .upgrade_package_content img {
	filter: grayscale(0);
}

.payment-method-item {
	display: flex;
	min-height: 180px;
	padding: 12px;
}

.img-gate-box {
	padding: 20px 25px 10px 25px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.img-gate-box img {
	width: 100%;
	height: 140px !important;
	object-fit: contain;
}

.payment-method-text {
	font-size: 14px;
	line-height: 19px;
	color: #000000;
	margin-top: 6px;
	text-align: center;
	margin-top: 10px;
	display: block;
}

.input-promotion {
	width: 90%;
}
</style>